"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHfilterState = void 0;
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var HfilterDistrictItem_init_1 = require("@/pages/search/states/HfilterDistrictItem.init");
var HfilterOption_init_1 = require("@/pages/search/states/HfilterOption.init");
var HfilterTranslateState_init_1 = require("@/pages/search/states/HfilterTranslateState.init");
var HfilterRange_init_1 = require("@/pages/search/states/HfilterRange.init");
var GetSuggestionApiResponse_1 = require("@/pages/search/states/GetSuggestionApiResponse");
exports.defaultHfilterState = {
    t: HfilterTranslateState_init_1.defaultHfilterTranslateState,
    keywordActive: false,
    fullKeywordActive: false,
    listingTypeActive: false,
    districtActive: false,
    priceActive: false,
    bedsActive: false,
    sizeActive: false,
    propertyTypeActive: false,
    amenityActive: false,
    sortPanelActive: false,
    listingType: SfilterTypeGroup_1.ListingPurposeType.Sale,
    districts: HfilterDistrictItem_init_1.defaultHfilterDistrictItems,
    appliedDistrictCount: 0,
    priceCustomReal: {
        rent: HfilterRange_init_1.defaultHfilterPriceRangeRealRent,
        sale: HfilterRange_init_1.defaultHfilterPriceRangeRealSale,
    },
    priceCustomMultiplied: {
        rent: HfilterRange_init_1.defaultHfilterPriceRangeMultipliedRent,
        sale: HfilterRange_init_1.defaultHfilterPriceRangeMultipliedSale,
    },
    priceCustomFromName: '0',
    priceCustomToRentName: '500K+',
    priceCustomToSaleName: '500M+',
    priceCustomUnit: { sale: 1000000, rent: 1000 },
    priceCustomUnitLabel: { sale: 'M', rent: 'K' },
    pricePresets: { sale: HfilterOption_init_1.defaultBuyPricePreset, rent: HfilterOption_init_1.defaultRentPricePreset },
    priceMin: 0,
    priceMax: -1,
    sizeCustomReal: HfilterRange_init_1.defaultHfilterSizeRangeReal,
    sizeCustomMultiplied: HfilterRange_init_1.defaultHfilterSizeRangeMultiplied,
    sizeCustomFromName: '0',
    sizeCustomToName: '5000+',
    sizeMin: 0,
    sizeMax: -1,
    sizePresets: HfilterOption_init_1.defaultSizePresets,
    bedsPresets: HfilterOption_init_1.defaultBedPresets,
    typeOptions: HfilterOption_init_1.defaultTypeOptions,
    amenityOptions: HfilterOption_init_1.defaultAmenityOptions,
    keyword: '',
    keywordSuggestionsLoading: false,
    keywordGroupIndex: -1,
    keywordRowIndex: -1,
    keywordHistoryGroups: [],
    keywordSuggestionGroups: [],
    isSearchKeywordFocus: false,
    vrVideoPresets: HfilterOption_init_1.defaultVrVideoPreset,
    sortOptions: HfilterOption_init_1.defaultSortOptions,
    fullDistrictActive: false,
    fullDistrictExpand: true,
    fullPriceExpand: true,
    fullSizeExpand: true,
    fullBedsExpand: true,
    fullPropertyTypeExpand: true,
    fullAmenitiesExpand: true,
    fullShowVrExpand: false,
    sortFullActive: false,
    filterFullActive: false,
    mapActive: true,
    hasUnsaved: false,
    searchResultId: 0,
    searchResultType: GetSuggestionApiResponse_1.GetSuggestionResultType.Keyword,
    isExclusive: false,
};
